<template>
  <div v-if="isVisible" class="agent-feature-promotion-banner" @click="onClickBanner">
    <div class="banner-content">
      <img class="banner-icon" :src="optimizeImage(detail.imageUrl)" loading="lazy" />
      <p class="banner-text" v-html="detail.text"></p>
    </div>
    <CloseCircleOutlineIcon :size="14" class="close-button" @click="closeBanner" />
  </div>
</template>

<script setup lang="ts">
import { ref, defineEmits, getCurrentInstance, defineProps } from "vue";
import CloseCircleOutlineIcon from "icons/CloseCircleOutline.vue";
import store from "@/store";
import { NolaAnalytics, NolaItemId } from "@/lib/utils/analytics";
import { optimizeImage } from "@/lib/utils/url";

defineProps<{
  detail: {
    imageUrl: string;
    text: string;
    promoBannerWordCount: number | null;
  };
}>();

const emit = defineEmits(["banner-click"]);

const instance = getCurrentInstance();
const nolaAnalytics = new NolaAnalytics(instance?.proxy.$gtm!, store);

const isVisible = ref(true);

const onClickBanner = () => {
  emit("banner-click");
  isVisible.value = false;
  updateDisplayedFlag();
  nolaAnalytics.logButtonEvent(NolaItemId.AgentFeaturePromotionBanner);
};

const closeBanner = () => {
  isVisible.value = false;
  updateDisplayedFlag();
  nolaAnalytics.logButtonEvent(NolaItemId.AgentFeaturePromotionBannerClose);
};

const updateDisplayedFlag = () => {
  if (!store.getters["generalModule/hasUsedAgentFeaturePromoBanner"]) {
    // 本コンポーネント利用済みフラグを立てる
    store.dispatch("generalModule/setUsedAgentFeaturePromoBanner", true);
  }
};
</script>

<style lang="scss" scoped>
.agent-feature-promotion-banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--color-background-normal);
  border-radius: var(--radius-sm);
  box-shadow: var(--shadow-sm);
  padding: 5px;
  position: relative;
  max-width: 400px;
  margin: 0 auto;
  cursor: pointer;
}

.banner-content {
  display: flex;
  align-items: center;
}

.banner-icon {
  width: 35px;
  height: 35px;
  margin-right: 6px;
  filter: var(--icon-filter-dark);
}

.banner-text {
  font-size: 9px;
  line-height: 1.5;
  color: var(--color-text-normal);
  font-weight: var(--font-weight-bold);
}

.close-button {
  color: var(--color-text-low);
  cursor: pointer;
  position: absolute;
  top: 4px;
  right: 4px;
}

.close-button:hover {
  color: var(--color-text-normal);
}
</style>
